import { ClockCircleFilled, ClockCircleOutlined, PlusOutlined, FilePdfOutlined} from "@ant-design/icons";
import { useCareCoordinationStore } from "@stores/useCareCoordinationStore";
import { Button, Checkbox, DatePicker, Input, Modal, notification, Collapse, Typography, Tabs } from "antd";
import { map, get, filter, includes, isEmpty, find, cloneDeep, head, set, forEach, noop, isEqual} from "lodash";
import moment, { Moment } from "moment";
import React, { FC, useEffect, useRef, useState , useMemo} from "react";
import { ACTIVE, COMPLETE, NOT_APPLICABLE } from "../../constants";
import Goal from "../goals/goal";
import Task from "../tasks/taskWithSubTask";
import ReviewReasons from "../reviewReasons/reviewReasons";
import "./intervention.scss";
import Icon from "../../../../../assets/icon_config";
import { DateRange } from "@components/dateRange";
import CareCoordinationService from "@services/care-coordination";
import { formatDisplayDate, caseLessComparision, getPasswordSecret, isAutoCaseStatus, milleniumClientCheck} from "@utils/helpers";
import {
  CASE_STATUS_CLOSED,
  CASE_STATUS_REASON_PROGRAM_CHANGE,
  USER_ACTION_MODULE_MEMBER_DETAIL,
  USER_ACTION_TAB_CARE_MANAGEMENT,
  USER_ACTION_LOCATION_PROGRAM,
  USER_ACTION_DESCRIPTION_PROGRAM_COMPLETE,
  USER_ACTION_CARD_PROGRAM,
  USER_ACTION_LOCATION_INTERVENTION_HEADER,
  CASE_STATUS_REASON_ASSIGNMENT,
  USER_ACTION_DESCRIPTION_PROGRAM_ASSIGNMENT,
  CPSR_REPORT_UPLOAD_PROGRESS_DATA,
} from "@utils/constants";
import classNames from "classnames";
import { CanEdit } from "@components/accessLevel";
import { usePatientProfileStore } from "@stores/patientProfileStore";
import membersService from "@services/members.service";
import sessionService from "@services/session.service";
import { useDropdowns, useHelperApiFunctions, useMultilevelSelectValue } from "@utils/customHooks";
import SimpleSelect from "@components/simpleSelect/simpleSelect";
import { useProgramMetaData , useProgramData , useConsent, useCompleteButtonData, useCarePlanReport} from "../../customHooks";
import DataNotFound from "@components/noDataFound";
import { NO_INSTANCE_ADDED, NO_INTERVENTIONS_ASSIGNED } from "../../../../../constants/constants";
import { CompleteButton, ReportToUpload, SubHeader } from "./interventionSubComp";
import { Spinner } from "@components/healthemSpinner/healthemSpinner";
import { truncate } from "fs";
var CryptoJS = require("crypto-js");

const { TabPane } = Tabs;

const { Panel } = Collapse;
const { Text } = Typography;

/******************************************************************************* */

// Code practice - while updating active program state of store, please update previous program state accordingly this is to handle and maintain history across intervention

/******************************************************************************* */

const Intervention = (props: any) => {

  const {interventions , patientProgramId , programDocs , consentId , completionReason } = useProgramData({});

  const {requireConsent , completionReasonMandatory , completionReasonRequired,isAutoUploadCPSRRequired , isAutoUploadCPSRDefaultChecked, defaultProgramPeriod, disableCompleteButton } = useProgramMetaData({programName : props.programName , patientId: props.patientId , programId : props?.programId , prgmGrpId : props?.prgmGrpId , prgmMetadata : props?.prgmMetadata});

  const {updateConsent, consent , consentLoader} = useConsent({programName : props.programName , patientId: props.patientId});

  const {remainingDays, completedDaysPercent, isAutoClosure} = useCompleteButtonData({defaultProgramPeriod , interventions});

  // getting state from the store
  const interventionOptions = useCareCoordinationStore((state) => state.interventionOptions);
  const setProgramsData = useCareCoordinationStore((state) => state.setDataForCareCoordination);
  const previousDataForCareCoordination = cloneDeep(useCareCoordinationStore((state) => state.previousDataForCareCoordination));
  const setPreviousDataForCareCoordination = useCareCoordinationStore((state) => state.setPreviousDataForCareCoordination);
  const isProgramValid = useCareCoordinationStore((state) => state.isProgramValid);
  const programsData = cloneDeep(useCareCoordinationStore((state) => state.dataForCareCoordination));
  const assignedPrograms = useCareCoordinationStore((state) => state.assignedPrograms);
  const setAssignedPrograms = useCareCoordinationStore((state) => state.setAssignedPrograms);
  const setisAllComplete = useCareCoordinationStore((state) => state.setisAllComplete);
  const [setMemberPageLoader] = usePatientProfileStore((state) => [state.setMemberPageLoader]);
  const [registryDependentProgramsStatus, setRegistryDependentProgramsStatus] = usePatientProfileStore((state) => [state.registryDependentProgramsStatus, state.setRegistryDependentProgramsStatus]);
  const careProgramAssigneeList = useCareCoordinationStore((state) => state.careProgramAssigneeList);


  // creating own state of the components
  const [AssigneeDetails, setAssigneeDetails] = useState<any>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [selectedValuesOfInterventions, setSelectedValuesOfInterventions] = useState([]);
  const [modalStartDate, setModalStartDate] = useState<Moment | null>(null);
  const [showAddNewIntervention, setShowAddNewIntervention] = useState(false);
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState<Moment | undefined>(undefined);
  const [endDate, setEndDate] = useState<Moment | undefined>(undefined);
  const [completeVisibility, setCompleteVisibility] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [modelData, setModelData] = useState({});
  const [isTargetDateLoading, setIsTargetDateLoading] = useState<boolean>(false);
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [prgmClouserReason , setPrgmClouserReason] = useState();
  const [programEndDate, setProgramEndDate] = useState<String | undefined>(interventions?.length > 0 ? interventions[0]?.endDate : undefined);
  const [uploadCareSummary , setUploadCareSummary] = useState<boolean | undefined>();
  const {isReportUploading , uploadReport ,fetchReportData ,isReportLoading , metaData , referralData , carePlanReportData , carePlanProgramData , rules } = useCarePlanReport();

  const uploadReportPayload = useMemo(() => {
    return {
      ...props.prgmMetadata.carePlanReportMetaData,
      patientId: props.patientId,
      programs: [
        {
          programId: props.programId,
          patientProgramId: patientProgramId,
          name: props.programName,
        },
      ],
    };
  }, [patientProgramId, props.patientId, props.prgmMetadata.carePlanReportMetaData, props.programId, props.programName]);

  const [infoModalData, setInfoModalData] = useState<{
    open: boolean;
    onClose: () => void;
    programsNeedToBeClosed: string[];
    ProgramName: string;
  }>({ open: false, onClose: noop, programsNeedToBeClosed: [], ProgramName: "" });
  const stopPropagation = useRef(true);

  const activeProgram = programsData;

  const { loadingOptions, filterDropdowns , getOptions } = useDropdowns();

  useEffect(() => {
    if(completionReasonRequired) {
      getOptions("PrgmCompleteReasonLst");
    }
  },[completionReasonRequired, getOptions]);

  // function responsible for showing the intervention options modal
  // const showModal = () => {
  //   setIsModalVisible(true);
  // };

  // params for update status for Program goals
  const currentMember = membersService?.getCurrentMember;
  const getUserActionParams = (userActionDescription: any, reason: any) => {
    let props = {
      caseStatusReasonTxt: reason,
      actionModule: USER_ACTION_MODULE_MEMBER_DETAIL,
      actionTab: USER_ACTION_TAB_CARE_MANAGEMENT,
      actionCard: `${get(programsData, 'displayName')}$|${get(programsData, "patientProgramId")}$|${USER_ACTION_CARD_PROGRAM}`,
      actionLocation: USER_ACTION_LOCATION_INTERVENTION_HEADER,
      actionDescription: userActionDescription,
    };
    return props;
  };

  // function responsible for handling the selected intervention options
  const handleOk = () => {
    if (isEmpty(selectedValuesOfInterventions)) {
      notification.error({
        message: "Please choose interventions",
      });
      return false;
    } else if (isEmpty(modalStartDate)) {
      notification.error({
        message: "Please choose Start Date of Intervention",
      });
      return false;
    } else {
      // API call will be there
      const newInterventions = map(selectedValuesOfInterventions, (intervention: any) => {
        return {
          id: intervention,
          interventionName: get(find(interventionOptions, { id: intervention }), "value", null),
          status: ACTIVE,
          startDate: modalStartDate,
          endDate: null,
          assignedTo: "1001", // to do
          assignedToName: "Diana Johns", // to do
          tasks: [],
          reminder: [],
          goals: [],
        };
      });

      activeProgram.interventions.push(...newInterventions);

      setProgramsData(programsData);
      setPreviousDataForCareCoordination(programsData);

      setIsModalVisible(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setCompleteVisibility(false);
    setModelData({});
    setMessage("");
    setPrgmClouserReason(undefined);
  };

  // modifying intervention options by excluding the already selected options
  const modifiedInterventionOptions = () => {
    const selectedInterventionIdArray = map(interventions || [], (intervention) => {
      return intervention?.id;
    });

    const interventionExcludedSelectedInterventions = filter(interventionOptions, (intervention) => {
      return !includes(selectedInterventionIdArray, intervention?.id);
    });

    if (!isEmpty(searchValue)) {
      const options = filter(interventionExcludedSelectedInterventions, (intervention) => {
        return includes(intervention.description, searchValue);
      });
      return options;
    } else {
      return interventionExcludedSelectedInterventions;
    }
  };

  // function responsible to set the state of selected interventions
  const handleSelectingIntervention = (checkedValues: any) => {
    setSelectedValuesOfInterventions(checkedValues);
  };

  const getProgramsNeedToBeClosed = ({ tasks = [] }: any) => {

    const returnArr: string[] = [];

    forEach(tasks, (task) => {
      forEach(task.subtasks, (subtask) => {
        if (subtask.type === 'ACTN-RADIOPRGM') {
          const program = find(assignedPrograms, (program) => caseLessComparision(program.name, subtask.name));
          if (program?.status === 'Active') {
            returnArr.push(program.description);
          }
        }
      });
    });
    return returnArr || [];
  }

  const saveNewIntervention = () => {
    // API call will be there
    const newIntervention = {
      id: new Date().toLocaleString(),
      interventionName: description,
      status: ACTIVE,
      startDate: startDate,
      endDate: endDate,
      assignedTo: "1001", // to do
      assignedToName: "Diana Johns", // to do
      tasks: [],
      reminder: [],
      goals: [],
    };

    activeProgram.interventions.push(newIntervention);

    setProgramsData(programsData);
    setPreviousDataForCareCoordination(programsData);
    setDescription("");
    setStartDate(undefined);
    setEndDate(undefined);
    setShowAddNewIntervention(false);
  };

  const {updateCurrentMemberData} = useHelperApiFunctions()
  const callbackForInterventionUpdationSuccess = (interventionObj : any , isUpdateProgram : boolean = false) => {
    const activeIntervention = find(activeProgram?.interventions, { id: interventionObj.interventionId });
    const activeInterventionPreviousState = find(previousDataForCareCoordination?.interventions, { id: interventionObj.interventionId });
    activeIntervention.status = interventionObj?.status;
    activeInterventionPreviousState.status = interventionObj?.status;
    if (interventionObj.endDate) {
      activeIntervention.endDate = interventionObj?.endDate;
      activeInterventionPreviousState.endDate = interventionObj?.endDate;
    }
    if (interventionObj.isAllComplete) {
      let tempAssignedPrograms = {
        ...activeProgram,
        interventions: activeProgram.interventions.map((interv: any) => {
          let tempIntervention = cloneDeep(interv);
          const intervPreviousState = find(previousDataForCareCoordination.interventions, { id: interv.id });
          if (interv.id === interventionObj?.interventionId) {
            tempIntervention = {
              ...interv,
              goals: interv?.goals?.map((interventionGoals: any) => {
                return {
                  ...interventionGoals,
                  goal_status: COMPLETE,
                };
              }),
              tasks: intervPreviousState?.tasks?.map((interventionTasks: any) => {
                return {
                  ...interventionTasks,
                  taskEndDate: props.programName === "HIC" ? interventionObj.endDate : interventionTasks?.taskEndDate,
                  status: interventionTasks.status === NOT_APPLICABLE ? NOT_APPLICABLE : COMPLETE,
                  reminders: interventionTasks.status === NOT_APPLICABLE ? interventionTasks?.reminders : interventionTasks?.reminders?.filter((reminder:any) => moment(formatDisplayDate(reminder.reminderStartDate, "reminderDateActualFormat", "reminderDateActualFormat", true)) < moment()),
                  subtasks: interventionTasks?.subtasks?.map((subTasks: any) => {
                    return {
                      ...subTasks,
                      reminders: interventionTasks.status === NOT_APPLICABLE ? subTasks?.reminders : subTasks?.reminders?.filter((reminder:any) => moment(formatDisplayDate(reminder.reminderStartDate, "reminderDateActualFormat", "reminderDateActualFormat", true)) < moment()),
                    }
                  })
                };
              }),
              status: interventionObj?.status,
            };
          }
          return tempIntervention;
        }),
      };
      activeProgram.interventions = tempAssignedPrograms.interventions;
      previousDataForCareCoordination.interventions = tempAssignedPrograms.interventions;
    }
    activeProgram.interventions = activeProgram.interventions.map((interv: any) => {
      if (interv.id === interventionObj.interventionId) {
        interv.status = interventionObj.status;
      }
      return interv;
    });
    previousDataForCareCoordination.interventions = previousDataForCareCoordination.interventions.map((interv: any) => {
      if (interv.id === interventionObj.interventionId) {
        interv.status = interventionObj.status;
      }
      return interv;
    });
    set(activeProgram , 'completionReason' , prgmClouserReason);
    if (isUpdateProgram === true) {
      updateProgramService()
      let tempAssignedPrograms = assignedPrograms.map((tempProgram: any) => {
        if (tempProgram.id === props?.programId) {
          tempProgram.status = COMPLETE;
        }
        return tempProgram;
      });
      let activeProgramsCount = tempAssignedPrograms.filter(
        (i: any) => i.status && i.status !== COMPLETE
      )
      if (activeProgramsCount.length === 0) {
        updateCurrentMemberData(props.patientId, { cadence_id: null, cadence_status: null })
      }
      setAssignedPrograms(tempAssignedPrograms);
    };
    setProgramsData(activeProgram);
    setPreviousDataForCareCoordination(previousDataForCareCoordination);
    setIsTargetDateLoading(false);
    setCompleteVisibility(false);
    setLoadingButton(false);
    setPrgmClouserReason(undefined);

    // If program status is complete than registry dependent checkbox will be enabled if there are any program associated with it
    if (interventionObj?.status === COMPLETE) {
      const tempRegistryDependentPrograms: any = cloneDeep(registryDependentProgramsStatus).filter((item: any) => item !== activeProgram?.description)
      setRegistryDependentProgramsStatus(tempRegistryDependentPrograms);
    }
  }

  const callbackForInterventionUpdationFailure = () => {
    setIsTargetDateLoading(false);
    setCompleteVisibility(false);
    setLoadingButton(false);
    setPrgmClouserReason(undefined);
  }
  
  const updateProgramCompletion = (interventionObj : any) => {
    
    CareCoordinationService.updateProgramCompletion({patientId : props.patientId ,prgmName : props.programName , patientPrgmId : patientProgramId , prgmClouserReason , consentId , prgmGrpId : props.prgmGrpId}).subscribe({
      next: (v) => {
        callbackForInterventionUpdationSuccess(interventionObj , true);
      },
      error: (e) => {
        callbackForInterventionUpdationFailure();
      },
    });
  }

  const updateInterventionService = (interventionObj: any) => {
    console.log("Intervention.updateInterventionService");
    CareCoordinationService.updateIntervention(interventionObj).subscribe({
      next: (v) => {
        callbackForInterventionUpdationSuccess(interventionObj)
      },
      error: (e) => {
        callbackForInterventionUpdationFailure();
      },
    });
  };

  const updateProgramService = () => {
    if((programsData?.assgnd_user_id === null || programsData?.assgnd_user_id === "null") && programsData?.assgnd_user_id !== "system")
    {
      CareCoordinationService.updateAssignedStatus({ programId: props?.programId, patientProgramId: patientProgramId, patientId: props.patientId, userId: sessionService?.getUser()?.id }).subscribe({
        next: (v) => {
          set(programsData, "assgnd_user_id", v.data.data.assignedTo);
          set(programsData, "userName", v.data.data.userName);
          setProgramsData(programsData);
          setAssignedUser(v.data.data.userName);
          CareCoordinationService.updateReminderStatus({ patientId: props?.patientId, assignedUserId: sessionService?.getUser()?.id, tasksId: taskId, subtasksId: subtaskId }).subscribe({
            next: (v) => {},
            error: (e) => {},
          });
          console.log("updated status successfully");
        },
        error: (e) => {
          console.log("update status failed");
        },
      });
    }
    CareCoordinationService.updateProgram({ patientId: props.patientId, programId: props?.programId, patientPgmId: patientProgramId, status: COMPLETE }).subscribe({
      next: (v) => {
        let tempAssignedPrograms = assignedPrograms.map((tempProgram: any) => {
          if (tempProgram.id === props?.programId) {
            tempProgram.status = COMPLETE;
          }
          return tempProgram;
        });
        setAssignedPrograms(tempAssignedPrograms);
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  const updateIntervention = ({ id, status, endDate, activeItems }: any) => {
    fetchReportData({payload : uploadReportPayload , callback : () => {
      let interventionObj: any = {
        patientId: props?.patientId,
        programId: props?.programId,
        patientPgmId: patientProgramId,
        interventionId: id,
        // description: name,
        // startDate: startDate,
        // endDate: endDate,
        status: status,
      };
      let message: string = "";
  
      const activeInterventionPreviousState = find(previousDataForCareCoordination?.interventions, { id: id });
  
      const programsNeedToBeClosed: string[] = getProgramsNeedToBeClosed({ tasks: activeInterventionPreviousState?.tasks });
  
      if (programsNeedToBeClosed.length > 0) {
        setInfoModalData({ open: true, onClose: () => { setInfoModalData({ open: false, onClose: noop, programsNeedToBeClosed: [], ProgramName: "" }) }, programsNeedToBeClosed, ProgramName: previousDataForCareCoordination.displayName });
        return;
      }
  
      if (!activeItems) {
        setisAllComplete("false");
      }
      if (activeItems && status === COMPLETE) {
        message = "There are open tasks and goals. Are you sure want to complete this Program and Active items ?";
        if (!isProgramValid(activeInterventionPreviousState)) {
          message = "There are open tasks, goals and some mandatory tasks. Are you sure want to complete this Program and Active items ?";
        }
  
        interventionObj["isAllComplete"] = "true";
        setisAllComplete("true");
      } else if (status === COMPLETE) {
        message = "Do you want to complete the Program ?";
        // interventionObj["isAllComplete"] = "true";
      }
      setMessage(message);
      setCompleteVisibility(!completeVisibility);
      setUploadCareSummary(isAutoUploadCPSRDefaultChecked);
      setModelData(interventionObj);
    }});
  };

  const deleteIntervention = ({ interventionId }: any) => {
    // API call for deleting the intervention

    activeProgram.interventions = filter(activeProgram?.interventions, (intervention) => intervention.id !== interventionId);

    CareCoordinationService.deleteIntervention({ programId: props?.programId, patientProgramId: patientProgramId, patientId: props.patientId, interventionId: interventionId }).subscribe({
      next: (v) => {
        setProgramsData(programsData);
        setPreviousDataForCareCoordination(programsData);
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  const disabledDate = (current: any) => {
    // Can not select days before today and today
    return current && current < moment().subtract(1, "days");
  };

  const onChangeTargetDate = (date: any, interventionObject: any) => {
    // service call
    setIsTargetDateLoading(true);
    let interventionObj: any = {
      ...interventionObject,
      endDate: moment.utc(date),
      programName : props.programName
    };
    // console.log(date);
    updateInterventionService(interventionObj);
  };

  //Complete Intervention
  const completeIntervention = () => {
    let _modelData = cloneDeep(modelData);
    if (props.programName === "HIC") {
      _modelData = { ..._modelData, endDate: moment.utc(), programName : props.programName};
    }
    updateProgramCompletion(_modelData);
    if(uploadCareSummary) {
      uploadReport({metaData : metaData, programs : uploadReportPayload.programs });
    }
    updatePatientCaseStatus(uploadCareSummary);
  };

  const updatePatientCaseStatus = (uploadCareSummary?: boolean) => {
    let forceStatus: any = undefined

    if (milleniumClientCheck()) {
      let selectedProgram = assignedPrograms.find((i: any) => i.id === props.programId)

      let activeAutomationPrograms = assignedPrograms.filter(
        (i: any) => {
          return i.id !== props.programId && i.status === 'Active' && i?.prgmMetadata?.isCaseStatusAutomation === true && i?.patientProgramId !== null
        }
      )

      if (selectedProgram?.prgmMetadata?.isCaseStatusAutomation === true && activeAutomationPrograms.length === 0) {
        let prgmCompleteReasonLst = get(filterDropdowns, "PrgmCompleteReasonLst", [])
        let reason = prgmCompleteReasonLst.find(
          (i: any) => {
           return  i.value === prgmClouserReason
          }
        )
        if (reason.metadata) {
          forceStatus = reason?.metadata?.caseStatusMatch || undefined
        }
      }
    }

    if (membersService.getCurrentMember.patient_case_status !== CASE_STATUS_CLOSED) {
      setMemberPageLoader(true);
      setTimeout(
        () => {
      membersService
        .updateStatus(
          props?.patientId,
          CASE_STATUS_REASON_PROGRAM_CHANGE,
          USER_ACTION_MODULE_MEMBER_DETAIL,
          USER_ACTION_TAB_CARE_MANAGEMENT,
          `${get(programsData, 'displayName')}$|${get(programsData, "patientProgramId")}$|${USER_ACTION_CARD_PROGRAM}`,
          `${get(programsData, 'displayName')}$|${USER_ACTION_LOCATION_PROGRAM}`,
          USER_ACTION_DESCRIPTION_PROGRAM_COMPLETE,
          isAutoCaseStatus(forceStatus)
        )
        .subscribe({
          next: (res: any) => {
            let currentMember = { ...membersService.getCurrentMember };
            currentMember.patient_case_status = res?.data?.data?.caseStatus;
            currentMember.case_last_action_date = res?.data?.data?.caseLastActionDate;
            membersService.setCurrentMember = currentMember;
            let tempMemberList = [...membersService.getMemberList];
            tempMemberList = tempMemberList.map((item: any) => {
              let mem = cloneDeep(item);
              if (currentMember?.patient_id === mem?.patient_id) {
                mem = {
                  ...mem,
                  ...currentMember,
                };
              }
              return mem;
            });
            membersService.setMemberList = tempMemberList;
            setMemberPageLoader(false);
          },
          error: (error: any) => setMemberPageLoader(false),
        });
      },
      uploadCareSummary ? 5000 : 0
    )
    }
  };

  const [openAssigneeList, setOpenAssigneeList] = useState<boolean>(false)
  const [assigneeHasAccess, setAssigneeHasAccess] = useState<boolean>(false);
  const [assigneeNoAccess, setAssigneeNoAccess] = useState<boolean>(false);
  const [assignedUser, setAssignedUser] = useState<any>();
  const [requiredUser, setRequiredUser] = useState<any>();

  const {value : userAssignmentVal} = useMultilevelSelectValue({selectedVal : programsData?.userName , data : AssigneeDetails});

  useEffect(() => {
    if (careProgramAssigneeList) {
      const newResponse = map(careProgramAssigneeList, (res) => {
        return {
          label: res.role_name,
          value: res.role_id,
          roleId: res.role_id,
          children: map(res.users, (child) => {
            return {
              label: child.user_name,
              value: child.user_id,
              userId: child.user_id,
              access: child.has_access
            };
          }),
        };
      });
      setAssigneeDetails(newResponse)
    }
  }, [careProgramAssigneeList])
  const [tempAssignee, settempAssignee] = useState<string>()
  const handleAssigneeList = (value: any) => {
    if(!isEqual(value , userAssignmentVal)) {
      settempAssignee(value)
      const requiredRole = careProgramAssigneeList?.find((item: any) => item?.role_id === value?.[0])
      const User = requiredRole?.users?.find((item: any) => item?.user_id === value?.[1])
      if (User?.has_access === 'Y') {
        setAssigneeHasAccess(true)
        setAssigneeNoAccess(false)
        console.log("User has Access")
      }
      else {
        setAssigneeHasAccess(false)
        setAssigneeNoAccess(true)
        console.log("User doesn't have Access")
      }
      setRequiredUser(User)
    }
  };
  const taskId = programsData?.interventions?.map((item: any) => {
    return item?.tasks?.map((task: any) => {
      return Number(task?.id);
    })
  }).flat(Infinity)
  const subtaskId = programsData?.interventions?.map((item: any) => {
    return item?.tasks?.map((task: any) => {
      return task?.subtasks?.map((subtask: any) => {
        return subtask?.id;
      })
    })
  }).flat(Infinity)
  const handleReassignment = (user: any) => {
    console.log('Intervention.updateAssignedStatus')
    if (user) {
      CareCoordinationService.updateAssignedStatus({ programId: props?.programId, patientProgramId: patientProgramId, patientId: props.patientId, userId: user?.user_id }).subscribe({
        next: (v) => {
          set(programsData, 'assgnd_user_id', v.data.data.assignedTo);
          set(programsData, 'userName', v.data.data.userName);
          setProgramsData(programsData);
          setAssignedUser(user?.user_name)
          setOpenAssigneeList(false);

          CareCoordinationService.updateReminderStatus({ patientId: props.patientId, assignedUserId: v.data.data.assignedTo, tasksId: taskId,subtasksId: subtaskId}).subscribe({
            next: (v) => {
              console.log("updated status successfully")
              CareCoordinationService.fetchProgramDetails({patientId: props.patientId}).subscribe({
                next: (v) => {
                  console.log("updated status successfully")
                },
                error: (e) => {
                  console.log("update status failed")
                },
              });
            },
            error: (e) => {
              console.log("update status failed")
            },
          });
        },
        error: (e) => {
          console.log(e);
        },
      });
      const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
        USER_ACTION_DESCRIPTION_PROGRAM_ASSIGNMENT,
        CASE_STATUS_REASON_ASSIGNMENT
      );
      membersService.updateStatus(currentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
        next: (v) => {
          console.log("updated status successfully")
        },
        error: (e) => {
          console.log("update status failed")
        },
      });
      console.log("requiredUser : ", user)
    }
    assigneeHasAccess ? setAssigneeHasAccess(!assigneeHasAccess) : setAssigneeNoAccess(!assigneeNoAccess)
  }
  const handleOpenChange = (newOpen: boolean) => {
    setOpenAssigneeList(newOpen);
  };

  const handleCancelAssignment =  () => {
    settempAssignee(undefined)
    assigneeHasAccess ? setAssigneeHasAccess(!assigneeHasAccess) : setAssigneeNoAccess(!assigneeNoAccess)
  }
  

  return (
    <Spinner loading={isReportUploading} size={60} progressBarNeeded={true} progressData={CPSR_REPORT_UPLOAD_PROGRESS_DATA} timeLimit={10000}>
      <div className="ui-program-interventions">
        {/* intervention Options Pop Up */}
        <Modal title="Intervention Options" open={isModalVisible} onCancel={handleCancel} onOk={handleOk}>
          <div className="ui-program-interventions__intervention-options">
            <Button
              className="ui-program-interventions__intervention-options__new-intervention"
              type="text"
              icon={<PlusOutlined />}
              onClick={() => {
                setShowAddNewIntervention(true);
                handleCancel();
              }}
            >
              New Intervention
            </Button>
            <div>
              <Input
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
                placeholder="Type to Search"
                className="ui-program-interventions__intervention-options__search-input"
              />
              <DatePicker
                value={modalStartDate}
                disabledDate={disabledDate}
                onChange={(date) => {
                  setModalStartDate(date);
                }}
              />
            </div>
            <Checkbox.Group
              className="ui-program-interventions__intervention-options__options"
              value={selectedValuesOfInterventions}
              onChange={(checkedValues) => handleSelectingIntervention(checkedValues)}
            >
              {map(modifiedInterventionOptions(), (intervention) => {
                return (
                  <Checkbox key={intervention?.id} value={intervention?.id}>
                    {intervention?.value}
                  </Checkbox>
                );
              })}
            </Checkbox.Group>
          </div>
        </Modal>

        {/* Completing Intervention Modal */}
        <Modal wrapClassName="completeIntervention" centered open={completeVisibility} footer={false} onCancel={handleCancel}>
          <p className="completeIntervention__header">{"Complete Program"}</p>
          <div className="completeIntervention__message">
            <span>
              <Icon name="alert-message" />
            </span>
            <span className="completeIntervention__message__body">{message}</span>
          </div>
          {completionReasonRequired && (
            <div className="completeIntervention__reason">
              <span className="completeIntervention__reason-heading">Reason for Completion {completionReasonMandatory && <span className="completeIntervention__reason-mandatory">*</span>}</span>
              <div className="completeIntervention__reason-dropdown">
                <SimpleSelect
                  handleSelect={(value) => setPrgmClouserReason(value)}
                  value={prgmClouserReason}
                  options={get(filterDropdowns, "PrgmCompleteReasonLst", [])}
                  placeholder={"Select Completion Reason"}
                  loadingOptions={loadingOptions}
                />
              </div>
            </div>
          )}
          {isAutoUploadCPSRRequired && (
            <Checkbox onChange={(e) => setUploadCareSummary(e.target.checked)} checked={uploadCareSummary}>
              Upload Care Summary Report to EMR
            </Checkbox>
          )}
          <p className="completeIntervention__buttons">
            <Button size="large" className="cancel-button completeIntervention__cancel" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              type="primary"
              size="large"
              className="f16 w500 yes-button completeIntervention__complete"
              loading={loadingButton}
              disabled={disableCompleteButton(prgmClouserReason)}
              onClick={async () => {
                setLoadingButton(!loadingButton);
                // props.programName === "HIC" ? await onChangeTargetDate(moment.utc(), modelData) : noop();
                completeIntervention();
              }}
            >
              Complete
            </Button>
          </p>
          <ReportToUpload payload={uploadReportPayload} referralData={referralData} carePlanReportData={carePlanReportData} carePlanProgramData={carePlanProgramData} rules={rules} />
        </Modal>

        {/* add new custom intervention div*/}
        {showAddNewIntervention && (
          <div className="ui-program-interventions__intervention">
            <div className="ui-program-interventions__intervention__detail">
              <Input
                placeholder="Enter Name of Intervention"
                value={description}
                bordered={false}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                className="ui-program-interventions__intervention__detail__name"
              />
              <DateRange
                rangeStartDate={startDate}
                rangeEndDate={endDate}
                handleDateChange={(range: any[]) => {
                  setStartDate(range[0]);
                  setEndDate(range[1]);
                }}
                format={"DD MMM'YY"}
                format_1={"YYYY-MM-DD"}
                format_2={"DD/MM/YYYY"}
                picker="date"
                disabledDate={disabledDate}
                className="ui-program-interventions__intervention__detail__date-range"
              />
              <Button type="primary" onClick={saveNewIntervention}>
                Save
              </Button>
            </div>
          </div>
        )}

        {/* listing the interventions Result.data.program*/}
        {!props.programStatus || isEmpty(interventions || []) ? (
          <div className="no-instance__message">{!props.programStatus ? <DataNotFound message={NO_INSTANCE_ADDED} /> : <DataNotFound message={NO_INTERVENTIONS_ASSIGNED} />}</div>
        ) : (
          map(interventions || [], (intervention: any) => {
            const interventionId = get(intervention, "id", null);
            const interventionStatus = get(intervention, "status", ACTIVE);
            const interventionGoals = get(intervention, "goals", []);
            const interventionTasks = get(intervention, "tasks", []);
            const interventionEndDate = get(intervention, "endDate", null);
            const interventionName = get(intervention, "description", "-");
            const interventionDetails = get(intervention, "interventionDetails", []);
            const interventionInfo = get(intervention, "info", null);
            const _dischargeDate = moment.utc(interventions[0]?.startDate, "YYYY-MM-DD HH:mm:ss.SSS").local();
            const interventionObject = {
              patientId: props?.patientId,
              programId: props?.programId,
              patientPgmId: patientProgramId,
              interventionId: interventionId,
              status: interventionStatus,
            };
            const activeTasks = filter(interventionTasks, (item) => {
              return item?.status !== COMPLETE;
            });
            const activeGoals = filter(interventionGoals, (item) => {
              return item?.goal_status !== COMPLETE;
            });
            const isAutoClosed = programsData?.isAutoClosed;

            return (
              <div className="ui-program-interventions__intervention" key={`${interventionId}`}>
                <div className="ui-program-interventions__intervention__detail">
                  <div className="ui-program-interventions__intervention__detail__name">
                    {/*the enrolle button is not required as of 1.5 release requirement so the below code is commented*/}
                    {/* {requireConsent && (
                      <Spinner loading={consentLoader} tooltip={consent.value ? `Patient Enrolled on: ${consent.date}` : "Patient Not Enrolled"}>
                        <span
                          className={`ui-program-interventions__intervention__detail__icon ${interventionStatus !== ACTIVE ? "disabled" : ""}`}
                          onClick={() => updateConsent(consent.value, interventionStatus)}
                        >
                          <Icon name="consent" colorOfBrand={consent.value ? "#0072E3" : ""} />
                        </span>
                      </Spinner>
                    )} */}
                    <span>{interventionName}</span>
                  </div>
                  <div className="ui-program-interventions__intervention__detail__secondary-header">
                    <SubHeader
                      assignedPrograms={assignedPrograms}
                      setProgramLoading={props.setProgramLoading}
                      initialLoad={props.initialLoad}
                      programId={props.programId}
                      patientProgramId={props.patientProgramId}
                      dischargeDate={_dischargeDate}
                      interventionStatus={interventionStatus}
                      isTargetDateLoading={isTargetDateLoading}
                      interventionEndDate={interventionEndDate}
                      onChangeTargetDate={onChangeTargetDate}
                      interventionObject={interventionObject}
                      programsData={programsData}
                      openAssigneeList={openAssigneeList}
                      handleOpenChange={handleOpenChange}
                      setOpenAssigneeList={setOpenAssigneeList}
                      tempAssignee={tempAssignee}
                      userAssignmentVal={userAssignmentVal}
                      AssigneeDetails={AssigneeDetails}
                      handleAssigneeList={handleAssigneeList}
                      assigneeHasAccess={assigneeHasAccess}
                      assigneeNoAccess={assigneeNoAccess}
                      handleCancelAssignment={handleCancelAssignment}
                      handleReassignment={handleReassignment}
                      requiredUser={requiredUser}
                      isAutoClosed={isAutoClosed}
                    />
                    <div className="ui-program-interventions__intervention__detail__right-options">
                      {props.programName !== "CCM" && (
                        <span className="ui-program-interventions__intervention__detail__right-options__spacing ui_goals">
                          <Goal goals={get(intervention, "goals", [])} interventionId={interventionId} programId={props?.programId} patientId={props.patientId} />
                        </span>
                      )}
                      {props.programName === "CCM" && <PdfModal programDocs={programDocs} />}
                      <CanEdit>
                        <span className="ui-program-interventions__intervention__detail__right-options__spacing">
                          <Button
                            type="text"
                            icon={<Icon name="delete" colorOfBrand="#DFE1E6" />}
                            onClick={() => deleteIntervention({ interventionId })}
                            disabled
                            // disabled={interventionStatus === COMPLETE || !isEmpty(interventionGoals) || !isEmpty(interventionTasks)}
                          />
                        </span>
                      </CanEdit>
                      <CompleteButton
                        completionReason={completionReason}
                        interventionStatus={interventionStatus}
                        isAutoClosure={isAutoClosure}
                        completedDaysPercent={completedDaysPercent}
                        updateIntervention={updateIntervention}
                        interventionId={interventionId}
                        activeTasks={activeTasks}
                        activeGoals={activeGoals}
                        remainingDays={remainingDays}
                        isAutoClosed={isAutoClosed}
                        isLoading={isReportLoading}
                      />
                    </div>
                  </div>
                </div>
                {interventionDetails.length > 0 ? (
                  <InterventionInfo
                    programName={props.programName}
                    interventionDetails={interventionDetails}
                    interventionObject={interventionObject}
                    updateInterventionService={updateInterventionService}
                    showClock={interventionInfo === "enablePrevious"}
                  />
                ) : null}

                {/* need to show review reasons only for HIC Program */}
                {props.programName === "HIC" && (
                  <ReviewReasons tasks={interventionTasks} interventionId={interventionId} patientId={props.patientId} programId={get(props, "programId", null)} patientProgramId={patientProgramId} />
                )}

                <Task
                  tasks={interventionTasks}
                  programEndDate={programEndDate}
                  setProgramEndDate={setProgramEndDate}
                  updatedProgramEndDate={interventionEndDate}
                  stopPropagation={stopPropagation}
                  interventionId={interventionId}
                  programId={get(props, "programId", null)}
                  patientProgramId={patientProgramId}
                  patientId={props.patientId}
                  onChangeProgram={props.onChangeProgram}
                  programName={props.programName}
                  canEdit={true}
                  showAssignee={true}
                />
                <InfoModal data={infoModalData} />
              </div>
              //   </Panel>
              // </Collapse>
            );
          })
        )}
      </div>
    </Spinner>
  );
};

export const InterventionPreloader = () => {
  return (
    <div className="ui-program-interventions-preloader">
      {map(["a", "b", "c"], (item) => {
        return (
          <div key={item} className="ui-program-interventions-preloader__intervention">
            <div className="ui-program-interventions-preloader__intervention__info">
              <div className="ui-program-interventions-preloader__intervention__info__name shimmerBG" />
              <div className="ui-program-interventions-preloader__intervention__info__date-range shimmerBG" />
              <div className="ui-program-interventions-preloader__intervention__info__icons">
                <div className="ui-program-interventions-preloader__intervention__info__icons__icon shimmerBG" />
                <div className="ui-program-interventions-preloader__intervention__info__icons__icon shimmerBG" />
                <div className="ui-program-interventions-preloader__intervention__info__icons__icon shimmerBG" />
              </div>
              <div className="ui-program-interventions-preloader__intervention__info__name shimmerBG" />
            </div>
            <div className="ui-program-interventions-preloader__intervention__tasks">
              {map(["d", "e", "f"], (_item) => {
                return (
                  <div key={_item} className="ui-program-interventions-preloader__intervention__tasks__info">
                    <div className="ui-program-interventions-preloader__intervention__tasks__info__name shimmerBG" />
                    <div className="ui-program-interventions-preloader__intervention__tasks__info__icons">
                      <div className="ui-program-interventions-preloader__intervention__tasks__info__icons__icon shimmerBG" />
                      <div className="ui-program-interventions-preloader__intervention__tasks__info__icons__icon shimmerBG" />
                      <div className="ui-program-interventions-preloader__intervention__tasks__info__icons__icon shimmerBG" />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}{" "}
    </div>
  );
};

export default Intervention;

const InterventionValue = ({info} : any) => {


  return (
    <Text
      style={
        info?.value?.length > 10
          ? {
              width: "7.8rem",
            }
          : undefined
      }
      ellipsis={
        info?.value?.length > 10
          ? {
              tooltip:
              info?.type === "INFO-DATE" || info?.type === "INFO-DATETIME"
                  ? moment(info?.value).isValid()
                    ? info?.type === "INFO-DATETIME"
                      ? formatDisplayDate(info?.value?.trim(), "reminderDateActualFormat", "defaultDateFormatWithTime", true)
                      : formatDisplayDate(info?.value?.trim(), "createDateFormat", "defaultDateFormat")
                    : info?.value
                  : info?.value,
            }
          : false
      }
    >
      {isEmpty(info?.value)
        ? "--"
        : info?.type === "INFO-DATE" || info?.type === "INFO-DATETIME"
        ? moment(info?.value).isValid()
          ? info?.type === "INFO-DATETIME"
            ? formatDisplayDate(
                moment.isMoment(info?.value) ? info?.value.utc().format() : info?.value?.trim(),
                "reminderDateActualFormat",
                "defaultDateFormatWithTime",
                true
              )
            : formatDisplayDate(moment.isMoment(info?.value) ? info?.value.utc().format() : info?.value?.trim(), "createDateFormat", "defaultDateFormat")
          : info?.value
        : info?.value}
    </Text>
  );
}; 

const InterventionInfoTemplate = ({ info , extra, index , showClock}: any) => {

  
  const [showPreviousValues, setShowPreviousValues] = useState(false);
  const labelClass = classNames("intervention-info__item__label", {
    "intervention-info__item__label--longer": index === 2,
  });
  return (
    <div key={info?.label} className={`intervention-info__item ${extra === "lesserItems" ? "lesserItems" : extra === "nonCollapsible" ? "nonCollapsible" : ""}`}>
      <div className={labelClass}>
        {info?.label.includes("(") ? (
          <div>
            {info?.label
              .trim()
              .split("(")
              .map((item: any, index: React.Key | null | undefined) => (
                <div key={index} className={`${item.includes(")") ? "subtitile" : ""}`}>
                  {item.includes(")") ? item.split(/[(,)]/).join("").trim() : item}
                </div>
              ))}
          </div>
        ) : (
          <div>{info?.label}</div>
        )}
      </div>
      <div className="intervention-info__item__divider"> : </div>
      <div className="intervention-info__item__value">
       <InterventionValue info={info}/>
        {showPreviousValues ? (
          <div className="subtitile subtitile--highlight">
            {info?.type === "INFO-DATE" || info?.type === "INFO-DATETIME"
              ? moment(info?.extendedValue2).isValid()
                ? info?.type === "INFO-DATETIME"
                  ? formatDisplayDate(info?.extendedValue2?.trim(), "reminderDateActualFormat", "defaultDateFormatWithTime" , true)
                  : formatDisplayDate(info?.extendedValue2?.trim(), "createDateFormat", "defaultDateFormat")
                : info?.extendedValue2
              : info?.extendedValue2}
          </div>
        ) : (
          <div className="subtitile">
            {moment(info?.extendedValue1?.trim(), "YYYY-MM-DD HH:mm:ss", true).isValid()
              ? formatDisplayDate(info?.extendedValue1?.trim(), "reminderDateActualFormat", "unitedStateDateTimeFormatWithoutSeconds")
              : info?.extendedValue1}
          </div>
        )}
      </div>
      {index === 2 && false ? (
        showPreviousValues ? (
          <Button
            onClick={(e) => {
              e.stopPropagation();
              setShowPreviousValues(!showPreviousValues);
            }}
            type="text"
            className="intervention-info__previous-value"
            disabled={!showClock}
            icon={<ClockCircleFilled />}
          ></Button>
        ) : (
          <Button
            onClick={(e) => {
              e.stopPropagation();
              setShowPreviousValues(!showPreviousValues);
            }}
            type="text"
            className="intervention-info__previous-value"
            disabled={!showClock}
            icon={<ClockCircleOutlined />}
          ></Button>
        )
      ) : null}
    </div>
  );
};

// component we are using for intervention Details
const InterventionInfo: FC<any> = ({ interventionDetails, showClock }) => {
  const interventionDetailCollapse = useCareCoordinationStore((state) => state.interventionDetailCollapse);
  const setInterventionDetailCollapse = useCareCoordinationStore((state) => state.setInterventionDetailCollapse);

  const onCollapseChange = () => {
    if (interventionDetailCollapse.length > 0) {
      setInterventionDetailCollapse([]);
    } else setInterventionDetailCollapse(["1"]);
  };

  const genExtra = () => {
    return interventionDetails.slice(0, 3).map((info: any, index: any) => {
      return  <InterventionInfoTemplate {...{info , index , showClock }} />
    });
  };
  return (
    <div className="intervention-info ">
      {interventionDetails && interventionDetails.length > 0 ? (
        <>
          {interventionDetails.length <= 3 ? (
            interventionDetails.map((info: any) => {
              return <InterventionInfoTemplate {...{info , extra: interventionDetails.length < 3 ? "lesserItems" : "nonCollapsible"}} />;
            })
          ) : (
            <Collapse
              accordion
              expandIconPosition="right"
              bordered={false}
              activeKey={interventionDetailCollapse}
              onChange={() => {
                onCollapseChange();
              }}
            >
              <Panel header={""} key={"1"} extra={genExtra()}>
                {interventionDetails.slice(3).map((info: any) => {
                  return <InterventionInfoTemplate {...{info , showClock}} />
                })}
              </Panel>
            </Collapse>
          )}
        </>
      ) : null}
    </div>
  );
};

const PdfModal = (props: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeChronic, setActiveChronic] = useState<any>(head(props.programDocs));
  const [activeDoc, setActiveDoc] = useState<any>(find(activeChronic?.doc_name, { isDefault: "Y" }));

  const [value, setValue] = useState(50);
  const showModal = () => {
    setIsModalOpen(true);
    setValue(50);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // // Function will execute on click of button
  // const onButtonClick = (url: any) => {
  //   // using Java Script method to get PDF file
  //   fetch(url).then((response) => {
  //     response.blob().then((blob) => {
  //       // Creating new object of PDF file
  //       const fileURL = window.URL.createObjectURL(blob);
  //       // Setting various property values
  //       let alink = document.createElement("a");
  //       alink.href = fileURL;
  //       alink.download = activeDoc?.tab_name;
  //       alink.click();
  //     });
  //   });
  // };

  return props.programDocs ? (
    <>
      <Button type="text" onClick={showModal} icon={<Icon name="pdf" />}></Button>
      <Modal
        className="ui-pdf-download"
        footer={
          // <div className="ui-pdf-download__footer">
          //   <DownloadOutlined onClick={() => onButtonClick(CryptoJS.AES.decrypt(activeDoc.doc_path, getPasswordSecret()).toString(CryptoJS.enc.Utf8))} />
          //   <Slider
          //     className="ui-pdf-download__footer__slider"
          //     tooltipVisible={false}
          //     onChange={(val: number) => {
          //       setValue(val);
          //     }}
          //     defaultValue={value}
          //   />
          //   <div>{value * 2}</div>
          // </div>
          null
        }
        title="Reference or decision tree documents for Chronic Care Management"
        visible={isModalOpen}
        onCancel={handleCancel}
      >
        <Tabs
          activeKey={activeChronic?.chronic_name}
          onChange={(key) => {
            const x = find(props.programDocs, { chronic_name: key });
            setActiveChronic(x);
            setActiveDoc(head(x?.doc_name));
          }}
          type="editable-card"
          hideAdd={true}
          className="ui-pdf-download__outer-tabs"
        >
          {map(props.programDocs, (item) => {
            return (
              <TabPane className="ui-pdf-download__outer-tabs__tab-pane" tab={item.chronic_name} key={item.chronic_name} active={activeChronic.chronic_name === item.chronic_name}>
                <Tabs
                  activeKey={activeDoc?.tab_name}
                  onChange={(key) => {
                    setActiveDoc(find(activeChronic?.doc_name, { tab_name: key }));
                  }}
                  type="editable-card"
                  hideAdd={true}
                  className="ui-pdf-download__outer-tabs__tab-pane__inner-tabs"
                >
                  {map(item.doc_name, (doc) => {
                    const url = CryptoJS.AES.decrypt(doc.doc_path, getPasswordSecret()).toString(CryptoJS.enc.Utf8);
                    return (
                      <TabPane
                        className="ui-pdf-download__outer-tabs__tab-pane__inner-tabs__tab-pane"
                        tab={
                          <div className="ui-pdf-download__outer-tabs__tab-pane__inner-tabs__tab-pane__title">
                            <FilePdfOutlined />
                            <div>{doc.tab_name}</div>{" "}
                          </div>
                        }
                        key={doc.tab_name}
                        active={activeDoc?.tab_name === doc.tab_name}
                      >
                        <iframe title="abc" src={url} width={`${value * 2}%`} height="98%" className="custom-scroll-bar"></iframe>
                      </TabPane>
                    );
                  })}
                </Tabs>
              </TabPane>
            );
          })}
        </Tabs>
      </Modal>
    </>
  ) : (
    <></>
  );
};


const InfoModal = ({ data }: any) => {
  const { open = false, onClose = noop, programsNeedToBeClosed = [], ProgramName = "" } = data;

  return (
    <Modal wrapClassName="custom-action-modal close_btn" title={""} centered open={open} footer={null} onCancel={onClose}>
      <p className="completeIntervention__header">{"Complete Program"}</p>
      <div className="completeIntervention__message">
        <span>
          <Icon name="alert-message" />
        </span>
        <span className="completeIntervention__message__body">{`You need to complete the ${programsNeedToBeClosed
          .join(", ")
          .replace(/,([^,]*)$/, " and$1")} program(s) before completing the ${ProgramName} Program`}</span>
      </div>
    </Modal>
  );
};
